import {Injectable} from "@angular/core";
import {AbstractSQLService} from "./AbstractSQLService";
import {Bioma} from "../../../domain/Bioma";

@Injectable()
export class BiomaSQLService extends AbstractSQLService<Bioma>{
    nomeTabela = "bioma"
    agenciavel = false
}
